/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSalesRepTrendFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SalesRepTrend } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/sales-reps/trend
 */
export interface TrendRequestBuilder extends BaseRequestBuilder<TrendRequestBuilder> {
    /**
     * The top reps by revenue in the window — ranked exactly as the sales rep leaderboard ranks them, by the orders recorded as taken by each rep — each with their revenue per day, week or month across the window, zero-filled, for a sparkline. A rep's days are read in UTC, so an order placed near local midnight can fall in the neighbouring day.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SalesRepTrend[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : Promise<SalesRepTrend[] | undefined>;
    /**
     * The top reps by revenue in the window — ranked exactly as the sales rep leaderboard ranks them, by the orders recorded as taken by each rep — each with their revenue per day, week or month across the window, zero-filled, for a sparkline. A rep's days are read in UTC, so an order placed near local midnight can fall in the neighbouring day.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * The top reps by revenue in the window — ranked exactly as the sales rep leaderboard ranks them, by the orders recorded as taken by each rep — each with their revenue per day, week or month across the window, zero-filled, for a sparkline. A rep's days are read in UTC, so an order placed near local midnight can fall in the neighbouring day.
 */
export interface TrendRequestBuilderGetQueryParameters {
    /**
     * The width of each trend point: Day, Week (weeks start on Monday) or Month. Defaults to Month.
     */
    bucket?: string;
    /**
     * End of the window, inclusive. At most two years after the start.
     */
    endDate?: Date;
    /**
     * How many reps, from the top of the revenue ranking. Defaults to 5; at most 20.
     */
    limit?: number;
    /**
     * Start of the window, inclusive.
     */
    startDate?: Date;
    /**
     * IANA time zone the window's buckets are laid out in, e.g. America/New_York. Defaults to UTC.
     */
    timeZone?: string;
}
/**
 * Uri template for the request builder.
 */
export const TrendRequestBuilderUriTemplate = "{+baseurl}/api/analytics/sales-reps/trend?bucket={bucket}&endDate={endDate}&limit={limit}&startDate={startDate}{&timeZone*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TrendRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TrendRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSalesRepTrendFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
